/**
 * Helper controller that encapsulates mouse dragging behaviour
 */
export class DragController {
  constructor($ui, name, callback) {
    const me = this;
    this.name = name;
    this.$ui = $ui;
    this.isDown = false;

    this.handlers = {
      mouseDown: function(e) {
        let pageInfo = undefined;
        if ( e.changedTouches && e.changedTouches.length > 0 ) {
          pageInfo = e.changedTouches[0]
        } else {
          pageInfo = e;
        }

        me.isDown = true;
        me.dragStartPos = {
          x: pageInfo.pageX,
          y: pageInfo.pageY
        }

        me.lastMousePos = {
          x: pageInfo.pageX,
          y: pageInfo.pageY
        }

        e.preventDefault();
      },

      mouseUp: function(e) {
        if ( me.isDown ) {
          me.isDown = false;
          let pageInfo = undefined;
          if ( e.changedTouches && e.changedTouches.length > 0 ) {
            pageInfo = e.changedTouches[0]
          } else {
            pageInfo = e;
          }

          let dif = {
            dx: pageInfo.pageX - me.lastMousePos.x,
            dy: pageInfo.pageY - me.lastMousePos.y,
            x: pageInfo.pageX - me.dragStartPos.x,
            y: pageInfo.pageY - me.dragStartPos.y
          }

          callback(me, dif);
        }
      },

      mouseMove: function(e) {
        if (me.isDown) {
          e.preventDefault();
          let pageInfo = undefined;
          if ( e.changedTouches && e.changedTouches.length > 0 ) {
            pageInfo = e.changedTouches[0];
          } else {
            pageInfo = e;
          }

          let dif = {
            dx: pageInfo.pageX - me.lastMousePos.x,
            dy: pageInfo.pageY - me.lastMousePos.y,
            x: pageInfo.pageX - me.dragStartPos.x,
            y: pageInfo.pageY - me.dragStartPos.y
          }

          me.lastMousePos = {
            x: pageInfo.pageX,
            y: pageInfo.pageY
          }

          callback(me, dif);
        }
      }
    }
  }

  /**
   * Attaches mouse event handlers to the provided elements or the $ui element passed
   * during instancing.
   * @param {Element} startElement An element to bind the mouse down event
   * @param {Element} moveElement An element to bind the movement events
   */
  attachHandlers(startElement, moveElement) {
    if ( !startElement ) {
      startElement = this.$ui.get(0);
    }
    if ( !moveElement ) {
      moveElement = window;
    }

    startElement.addEventListener("mousedown", this.handlers.mouseDown, false);
    startElement.addEventListener("touchstart", this.handlers.mouseDown, false);
    window.addEventListener("mouseup", this.handlers.mouseUp, false);
    window.addEventListener("touchend", this.handlers.mouseUp, false);
    moveElement.addEventListener("mousemove", this.handlers.mouseMove, false);
    moveElement.addEventListener("touchmove", this.handlers.mouseMove, { passive: false});
    const fixTouchMove = (e) => { return ; }
    document.body.removeEventListener("touchstart", fixTouchMove);
    document.body.addEventListener("touchstart", fixTouchMove);
  }

  /**
   * Detaches event handlers.
   * @param {Element} startElement The element mouse down event was bound.
   * @param {Element} moveElement The element mouse movement was bound.
   */
  detachHandlers(startElement, moveElement) {
    if ( !startElement ) {
      startElement = this.$ui.get(0);
    }
    if ( !moveElement ) {
      moveElement = window;
    }

    startElement.removeEventListener("mousedown", this.handlers.mouseDown);
    startElement.removeEventListener("touchstart", this.handlers.mouseDown);
    window.removeEventListener("mouseup", this.handlers.mouseUp);
    window.removeEventListener("touchend", this.handlers.mouseUp);
    moveElement.removeEventListener("mousemove", this.handlers.mouseMove);
    moveElement.removeEventListener("touchmove", this.handlers.mouseMove);
  }
}